import React, { useEffect, useState } from "react";
import styles from "./SelectDateRange.module.css";

const SelectDateRange = ({ font, titleState, setTitleState, businessName, error, setError, isCalendarVisible, setIsCalendarVisible, startDate, setStartDate, endDate, setEndDate }) => {
    const [isSelectingStartDate, setIsSelectingStartDate] = useState(true);

    useEffect(() => {
        if (isCalendarVisible) {
            const calendarContainer = document.querySelector(".auto-jsCalendar");
            if (calendarContainer && window.jsCalendar) {
                const initialDate = isSelectingStartDate ? startDate : endDate;
                const calendar = window.jsCalendar.new(calendarContainer, initialDate || new Date(), {
                    navigator: true,
                    navigatorPosition: "left",
                    zeroFill: true,
                    monthFormat: "month YYYY",
                    dayFormat: "DDD",
                    language: "en",
                });
                let td_elements = document.querySelectorAll("td");
                td_elements.forEach(td => { td.style.cursor = "pointer"; });
                calendar.onDateClick((event, date) => {
                    if (isSelectingStartDate) {
                        if (date > endDate) { 
                            setError("Start date cannot be later than end date.");
                            return; 
                        }
                        setStartDate(date);
                    } else {
                        if (date < startDate) { 
                            setError("End date cannot be earlier than start date.");
                            return; 
                        }
                        setEndDate(date);
                    }
                    setIsCalendarVisible(false);
                    setError(null);
                    setTitleState(`${businessName} revenue breakdown`);
                });
            }
        }
    }, [isCalendarVisible, isSelectingStartDate, startDate, endDate]);

    const handleStartDateClick = () => {
        setIsCalendarVisible(false);
        setTimeout(() => {
            setIsSelectingStartDate(true);
            setIsCalendarVisible(true);
            setTitleState("Select start date.");
        }, 0);
    };

    const handleEndDateClick = () => {
        setIsCalendarVisible(false);
        setTimeout(() => {
            setIsSelectingStartDate(false);
            setIsCalendarVisible(true);
            setTitleState("Select end date.");
        }, 0);
    };

    const removeCalendar = () => { 
        setIsCalendarVisible(false); 
        setTitleState(`${businessName} revenue breakdown`);
        setError(null);
    };

    return (
        <>
            <div className={`${styles.select_date_range_container} ${font} fade_in`}>
                <div className={`login_buttons ${styles.calendar_buttons}`} onClick={handleStartDateClick}>Start Date</div>
                <div className={`login_buttons ${styles.calendar_buttons}`} onClick={handleEndDateClick}>End Date</div>
                <p className={`${styles.start_date}`}>{startDate.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}</p>
                <p>---</p>
                <p className={`${styles.end_date}`}>{endDate.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}</p>
            </div>
            {isCalendarVisible && (
                <div className={styles.calendar_container}>
                    <div className="auto-jsCalendar" style={{ cursor: "pointer" }}></div>
                    <img src={`${process.env.PUBLIC_URL}/images/remove_popup.png`} className={styles.remove_calendar} onClick={() => removeCalendar()} alt="remove_calendar" />
                </div>
            )}
        </>
    );
};

export default SelectDateRange;
